// Static content & imagery for the AMF site.
export const IMAGES = {
  hero: "https://images.pexels.com/photos/34328138/pexels-photo-34328138.jpeg",
  schoolgirlConfident:
    "https://images.pexels.com/photos/34012022/pexels-photo-34012022.jpeg?auto=compress&cs=tinysrgb&w=1200",
  classroomReading:
    "https://images.unsplash.com/photo-1728743264687-d96fbda27a88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  girlFocus:
    "https://images.unsplash.com/photo-1744809495173-217ca4faa8bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  classroomGroup:
    "https://images.pexels.com/photos/34162709/pexels-photo-34162709.jpeg?auto=compress&cs=tinysrgb&w=1200",
  mentorWomen:
    "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mentorGroup:
    "https://images.unsplash.com/photo-1655720357872-ce227e4164ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  studentsOutside:
    "https://images.pexels.com/photos/36188072/pexels-photo-36188072.jpeg?auto=compress&cs=tinysrgb&w=1200",
  girlsStudy:
    "https://images.unsplash.com/photo-1761370981247-1dfd749ec96b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  girlSmile:
    "https://images.unsplash.com/photo-1660735148170-223b66e9f941?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  schoolgirlWhite:
    "https://images.unsplash.com/photo-1544476671-bfd151728e9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  girlsGroup:
    "https://images.unsplash.com/photo-1719667947229-594a8fdddade?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  classroomLibrary:
    "https://images.unsplash.com/photo-1728743264705-776882fce48d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  executiveDirector: "/board/ayisha.jpg",
};

export const CONTACT = {
  phone: "+233 544 696 207",
  email: "info@asanamemorialfoundation.org",
  address: "4th Street, Nii Torgbor Street, East Legon, Accra. GA-482-763",
};

export const MISSION_BAND = [
  {
    icon: "GraduationCap",
    title: "Education Access",
    text: "Supporting girls to enter, stay, and progress through school.",
  },
  {
    icon: "HeartHandshake",
    title: "Menstrual Dignity",
    text: "Ensuring no girl misses school because of her period.",
  },
  {
    icon: "Compass",
    title: "Mentoring & Leadership",
    text: "Building pathways for young women into leadership and public life.",
  },
];

export const IMPACT = [
  {
    number: "150+",
    label:
      "girls reached through the Menstrual Dignity Support Initiative",
  },
  {
    number: "2",
    label:
      "municipal stakeholder engagements completed (Adentan, La-Nkwantanang-Madina)",
  },
  { number: "4", label: "flagship campaigns in development" },
];

export const PRIMARY_FOCUS = [
  {
    n: "01",
    title: "Girls' Education Access and Retention",
    image: IMAGES.classroomReading,
    paras: [
      "AMF works to increase access to quality education for girls from disadvantaged backgrounds and to ensure retention at all levels of schooling.",
      "We intervene at critical points where girls are most likely to drop out due to poverty, early pregnancy, household responsibilities, or social pressure, through counselling, family engagement, academic support, and targeted financial assistance.",
      "Our approach is grounded in a simple principle: once a girl enters school, she should be supported to stay and succeed.",
    ],
  },
  {
    n: "02",
    title: "Menstrual Dignity Support (Dignity & Continuity Initiative)",
    image: IMAGES.classroomGroup,
    paras: [
      "AMF addresses a critical but often overlooked barrier to girls' school attendance: the inability to manage menstruation with dignity and consistency.",
      "Through the Dignity & Continuity Initiative, the Foundation provides essential menstrual hygiene kits, including sanitary pads and underwear, alongside practical education that enables girls to attend school confidently and without disruption.",
      "The initiative is structured as a consistent support mechanism within AMF's broader education retention strategy, ensuring that a preventable barrier does not interrupt a girl's learning journey.",
    ],
  },
  {
    n: "03",
    title: "Mentoring and Pathways for Young Women",
    image: IMAGES.mentorWomen,
    paras: [
      "Through structured mentoring and life-skills development, AMF supports adolescent girls and young women to build confidence, make informed decisions, and pursue realistic educational and career pathways.",
      "Our mentoring model connects beneficiaries with accomplished professionals locally and internationally, responding to documented gaps in guidance, role models, and psychosocial support for girls and young women transitioning through education and early adulthood.",
    ],
  },
];

export const SECONDARY_FOCUS = [
  {
    title: "Resource Mobilisation and Education Financing",
    text: "Economic hardship remains one of the strongest predictors of girls' educational exclusion. AMF mobilises financial and material resources to support school costs, learning materials, examinations, and progression into higher education or vocational pathways through partnerships, scholarships, and fundraising initiatives.",
  },
  {
    title: "Policy Advocacy and Systems Change",
    text: "AMF engages policymakers, education authorities, community leaders, and civil society actors to address systemic barriers. Our advocacy is evidence-based and aligned with Ghana's constitutional commitments and education policy framework.",
  },
  {
    title: "Community Engagement and Social Norms Transformation",
    text: "AMF works with families, traditional authorities, religious leaders, and opinion shapers to challenge norms that limit girls' education and women's participation, through dialogue, sensitisation, and storytelling.",
  },
];

export const APPROACH = [
  "Collaboration with government and partners",
  "Engagement with communities and families",
  "Networking with philanthropists and professionals",
  "Participatory research, learning, monitoring and evaluation",
];

export const CAMPAIGNS = [
  {
    title: "Once She Enters, She Stays",
    text: "Addressing the high risk of school dropout among girls at transition points where economic hardship, early pregnancy, household responsibilities, and social pressure interrupt education. Focuses on early identification of girls at risk, engagement with families and schools, mentoring support, and targeted educational assistance.",
  },
  {
    title: "The Big Push for Girls and Young Women",
    text: "AMF's flagship fundraising and partnership campaign, developed to mobilise resources that support education access, mentoring systems, and scholarships for girls and young women from disadvantaged backgrounds.",
  },
  {
    title: "Education, Leadership, Dignity",
    text: "A public engagement and advocacy campaign to strengthen community support for girls' education and young women's participation in leadership and public life, through community dialogue, mentoring, and policy engagement.",
  },
  {
    title: "Exam Readiness Support Programme",
    text: "A core AMF education initiative providing free, structured after-school revision classes in core subjects for final-year BECE and WASSCE students. Sessions run for approximately ninety minutes and include revision materials, light refreshments, and a safe study environment.",
  },
];

export const GALLERY = [
  { src: "/gallery/g3.jpg", caption: "AMF Foundation Gathering" },
  { src: "/gallery/g1.jpg", caption: "Stakeholder Engagement" },
  { src: "/gallery/g2.jpg", caption: "Community Engagement" },
];

export const VALUES_TEXT =
  "We combine direct support for girls and young women with community engagement and policy advocacy, addressing not just access to education, but the social and systemic barriers that determine whether opportunity is sustained.";
